export const handleChangeDataModalEditTransFactorNum = (name, value) => ({
    type: 'CHANGE_DATA_MODAL_EDIT_TRANS_FACTOR_NUM', name, value
});